import classNames from 'classnames';
import React from 'react';

var Spinner = function Spinner(_ref) {
  var className = _ref.className,
      _ref$ariaLabel = _ref['aria-label'],
      ariaLabel = _ref$ariaLabel === void 0 ? 'Laster innhold...' : _ref$ariaLabel;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('spinner', className),
    role: "img",
    "aria-label": ariaLabel
  });
};

Spinner.displayName = "Spinner";

export default Spinner;
//# sourceMappingURL=index.es.js.map
